// extracted by mini-css-extract-plugin
export const banner = "V_bw";